import styled from "styled-components";

export const FlexSearch = styled.div`
  width: 100%;
  height: 70px;
`;

export const WrapperButtonFeedback = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-end !important;
  justify-content: flex-end !important;
  padding-left: 1rem;
  padding-right: 1rem;

  button {
    width: 100%;
    height: 50px;
    background-color: black;
    border-radius: 10px;
    font-size: 1.6rem;
    color: white;
    margin-bottom: auto;
    transition: all 120ms linear;
    margin-top: auto;
    align-items: flex-end !important;
    justify-content: flex-end !important;
    :hover {
      background-color: ${({ theme }) => theme.colors.background};
    }
  }

  @media (max-width: 1366px) {
    /* transform: translateY(-57px); */
    min-height: 100px;
    margin: 0 0 4.5rem 0;

    button {
      font-size: 1.4rem;
    }
  }
`;

export const VerticalStack = styled.div`
  width: 100%;
  height: 100%;
  margin-bottom: 1rem;
  display: flex;
  flex-direction: column;
`;
